  <div id="particles-js"></div>
  <div class="text">
    <h1 id="title">404</h1>
    <p id="subtitle">Something went wrong.</p>
  </div>
